import { UserCreate } from '../../apis/user/userCreateApI';
import { userCheckEmail } from '../../apis/user/userCheckEmail';
import { userActivationGet, userActivationUpdate } from '../../apis/user/userCreateApI';
import { UserAccountActivationDTO } from '../../interfaces/UserAccountActivationDTO';
import { UserAccountLoginResponseDto } from '../../interfaces/UserAccountLoginResponseDto';

export const UserService = {
  create: async (
    name: string,
    password: string,
    email: string,
    type: string,
    socialNumber: string,
    enterpriseNumber: string,
    phone: string,
  ) => await UserCreate({ name, password, email, type, socialNumber, enterpriseNumber, phone }),
  checkEmail: async (email: string) => await userCheckEmail(email),
  activationGet: async (code: string): Promise<UserAccountActivationDTO> =>
    (await userActivationGet(code)) as UserAccountActivationDTO,
  activationUpdate: async (data: UserAccountActivationDTO): Promise<UserAccountLoginResponseDto> =>
    (await userActivationUpdate(data)) as UserAccountLoginResponseDto,
};
